import React from 'react';
import PropTypes from 'prop-types';

function TagFilterList({
  tags,
  totalCount,
  selectedTag = null,
  onTagSelected = () => { },
}) {
  return (
    <ul className="list-filters">
      <li className={(selectedTag === null ? 'active' : '')}>
        <a href="#" onClick={(e) => { onTagSelected(null); e.preventDefault(); }}>
          {`All (${totalCount})`}
        </a>
      </li>
      {Object.entries(tags).map(([tag, count]) => (
        <li key={tag} className={(tag === selectedTag ? 'active' : '')}>
          <a href="#" onClick={(e) => { onTagSelected(tag); e.preventDefault(); }}>
            {`${tag} (${count})`}
          </a>
        </li>
      ))}
    </ul>
  );
}

TagFilterList.propTypes = {
  tags: PropTypes.objectOf(PropTypes.number),
  totalCount: PropTypes.number,
  selectedTag: PropTypes.string,
  onTagSelected: PropTypes.func,
};

export { TagFilterList };
